export class Logger {
  disable(): void {
    return undefined;
  }

  enable(): void {
    return undefined;
  }

  log(): void {
    return undefined;
  }

  warn(): void {
    return undefined;
  }

  error(): void {
    return undefined;
  }
}
